import i18n from 'i18next';
import * as Yup from 'yup';
import { isInsuracePortalUser } from 'globalutils/fmUtils';
import { checkServiceProvider } from './serviceProviderConfig';

const layout = window?.$environment?.CURRENT_LAYOUT;
const provider = window?.$environment?.SERVICE_PROVIDER;

const isNotClutch = layout !== 'Clutch';
const validNameMsg = i18n.t('common.validName');
const requiredMsg = i18n.t('common.fieldRequiredMessage');
const isSchemaLayoutProvider = checkServiceProvider('schema_layout_provider', provider, false);

export const validationlist = {
  type: Yup.string().required(requiredMsg),
  name: Yup.string().required(requiredMsg).max(10, validNameMsg),
  esn: Yup.string().when(['trackingDevice'], {
    is: (value) => !!value?.value,
    then: Yup.string().required(requiredMsg),
    otherwise: Yup.string(),
  }),

  ...(isNotClutch && {
    next_maintenance_date: Yup.string().required(requiredMsg),
  }),

  ...((isNotClutch || isSchemaLayoutProvider) && {
    make: Yup.string().required(requiredMsg),
    model: Yup.string().required(requiredMsg),
  }),

  ...(!isNotClutch && {
    company: isInsuracePortalUser()
      ? Yup.string().required(requiredMsg)
      : Yup.string(),

  }),
};
